import Private from '@assets/icons/private.svg'
import { Icon } from './Icon'

export const PrivateIcon = Icon(Private)
